import { Indicator } from "../indicator/indicator";
import { EMA } from "./EMA";
//Form
// tema = 3 * ema(in) - 3 * ema(ema(in)) + ema(ema(ema(in)))
export class TEMA extends Indicator {
    constructor(input) {
        super(input);
        const period = input.period;
        const priceArray = input.values;
        let ema1;
        let ema2;
        let ema3;
        let format = this.format;
        this.result = [];
        let emaIndex = 0;
        const genFn = (function* () {
            ema1 = new EMA({
                period: period,
                values: [],
                format: (v) => { return Number(v.toFixed(2)); }
            });
            ema2 = new EMA({
                period: period,
                values: [],
                format: (v) => { return Number(v.toFixed(2)); }
            });
            ema3 = new EMA({
                period: period,
                values: [],
                format: (v) => { return Number(v.toFixed(2)); }
            });
            let tick = yield;
            while (true) {
                let lastEma = ema1.nextValue(tick);
                let emaDouble = lastEma ? ema2.nextValue(lastEma) : undefined;
                let emaTriple = emaDouble ? ema3.nextValue(emaDouble) : undefined;
                let result = emaTriple ? 3 * lastEma - 3 * emaDouble + emaTriple : undefined;
                tick = yield result ? format(Number(result.toFixed(2))) : undefined;
            }
        });
        this.generator = genFn();
        this.generator.next();
        priceArray.forEach((tick) => {
            const result = this.generator.next(tick);
            if (result.value != undefined) {
                this.result.push(this.format(result.value));
            }
        });
    }
    nextValue(price) {
        const result = this.generator.next(price).value;
        if (result !== undefined) {
            return this.format(result);
        }
    }
    ;
}
TEMA.calculate = tema;
export function tema(input) {
    Indicator.reverseInputs(input);
    const result = new TEMA(input).result;
    if (input.reversedInput) {
        result.reverse();
    }
    Indicator.reverseInputs(input);
    return result;
}
